const e = { last_updated: "Laatst herzien", Series_type: "Series", "How to guide_type": "Gids", FAQ_type: "Standaard" }, t = {
  articles: e
};
export {
  e as articles,
  t as default
};
//# sourceMappingURL=help-center-knowledge-anatomies34.js.map
